export enum ActionTypes {
  GetSubusers = 'getSubusers',
  GetSubusersRequest = 'getSubusers.request',
  GetSubusersSuccess = 'getSubusers.success',
  GetSubusersFailure = 'getSubusers.failure',
}
